import { configureStore } from "@reduxjs/toolkit";
import cemsSlice from "./features/cemsSlice";
import flareSlice from "./features/flareSlice";
import h2Slice from "./features/h2Slice";
import sepSlice from "./features/sepSlice";
import tispSlice from "./features/tispSlice";
import vupSlice from "./features/vupSlice";

export const store = configureStore({
  reducer: {
    TISP: tispSlice,
    VUP: vupSlice,
    CEMS: cemsSlice,
    SEP: sepSlice,
    H2: h2Slice,
    FLARE: flareSlice,
  },
});
